import { ViewableLayer } from "scene-manager";
import { ICanvasScaler } from "../../canvas/ICanvasScaler";
import { Scales } from "../../canvas/CanvasScaler";
import { IDestroyOptions } from "pixi.js";

export class PeskyMolesViewableLayer extends ViewableLayer {
    private fixedWidth: number;
    private fixedHeight: number;

    public constructor(
        private readonly canvasScaler: ICanvasScaler
    ) {
        super();
        this.fixedWidth = this.canvasScaler.referenceWidth;
        this.fixedHeight = this.canvasScaler.referenceHeight;
        this.onResize(this.canvasScaler.getSize());
        this.canvasScaler.onResize.add(this.onResize, this);
    }

    public override destroy(options?: IDestroyOptions | boolean): void {
        this.canvasScaler.onResize.remove(this.onResize, this);
        super.destroy(options);
    }

    private onResize(scales: Scales): void {
        this.height = this.canvasScaler.browserHeight;//scales.height;
        this.width = this.height * (scales.width / scales.height);
        this.scale.set(this.canvasScaler.browserHeight / scales.height);
        this.fixedWidth = this.canvasScaler.referenceWidth;
        this.fixedHeight = this.canvasScaler.referenceHeight;
        this.position.x = (this.canvasScaler.browserWidth - scales.width * this.scale.x) * 0.5;
    }

    public override calculateBounds(): void {
        this._bounds.clear();
        this._calculateBounds();
        this._bounds.updateID = this._boundsID;
    }

    protected override _calculateBounds(): void {
        this._bounds.addFramePad(0, 0, this.fixedWidth, this.fixedHeight, 0, 0);
    }

}
